
<div v-if="produitCollection || !isListeAuto" class="container-liste-liens">
  <Hyperlien
    v-if="content.lien"
    class="titre-liste-liens"
    :content="{
      texte: `${getTitre}` || '',
      type: 'lienTertiaire',
      lien: getLienTitre,
    }"
  />
  <EditableArea
    v-if="!isListeAuto"
    class="row no-gutters h-100 d-block pl-3 liste-liens"
    :content="content.listeLiens"
    :parentTemplateId="metadata['mgnl:template']"
  />
  <div v-else-if="produitCollection" class="row no-gutters h-100 d-block pl-3 liste-liens">
    <div v-for="produit in produits" :key="produit['@id']" class="d-flex">
      <Hyperlien
        :content="{
          texte: getTitreProduit(produit),
          type: 'lienTertiaire',
          lien: getLienProduit(produit),
        }"
      />
      <div
        v-if="
          content.isReglesDeJeux == 'true' &&
          (getPdf(produit).lienExterne || getPdf(produit).lienInterneAsset)
        "
        class="d-flex"
      >
        &nbsp;
        <Hyperlien
          :content="{
            texte: `| ${$t('regles')}`,
            type: 'lienTertiaire',
            lien: getPdf(produit),
          }"
        />
        &nbsp;
        <b-link
          :href="
            getPdf(produit).lienInterneAsset
              ? jel_getFichierSrc(getPdf(produit).lienInterneAsset)
              : getPdf(produit).lienExterne
          "
        >
          <svg-icon icon-name="ic-file"></svg-icon
          ><label class="sr-only">{{ $t('regles') }}</label>
        </b-link>
      </div>
    </div>
  </div>
</div>
